import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

interface ConfirmationDialogProps {
    open: boolean;
    onClose: () => void;
    title: string;
    description: any;
    primaryButtonText?: string;
    secondaryButtonText?: string;
    onPrimaryAction?: () => void;
    onSecondaryAction?: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
    open,
    onClose,
    title,
    description,
    primaryButtonText,
    secondaryButtonText,
    onPrimaryAction,
    onSecondaryAction
}) => {

    const handlePrimaryAction = () => {
        if (onPrimaryAction) {
            onPrimaryAction();
        }
        onClose();
    };

    const handleSecondaryAction = () => {
        if (onSecondaryAction) {
            onSecondaryAction();
        }
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} aria-labelledby="confirmation-dialog-title" aria-describedby="confirmation-dialog-description">
            <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="confirmation-dialog-description">
                    {description}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {secondaryButtonText && (
                    <Button onClick={handleSecondaryAction} color='inherit'>{secondaryButtonText} </Button>
                )}

                {primaryButtonText && (
                    <Button onClick={handlePrimaryAction} color="primary" autoFocus>{primaryButtonText} </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;